export default {
	// defaultColumnWidth: 150,
	// Our default row height
	defaultRowHeight: 60,
};
